"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Building2, HeartHandshake, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ParaTiendas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="para-tiendas" className="bg-background py-48 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.02] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/paco_herminia_family_crest_watermark.png)] bg-center bg-no-repeat bg-contain pointer-events-none" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div ref={ref} className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="shadow-none border-none">
            <CardHeader className="text-center pb-4">
              <CardTitle className="text-3xl md:text-4xl tracking-tight font-serif">
                Socio Estratégico para Tiendas Gourmet
              </CardTitle>
            </CardHeader>

            <CardContent className="space-y-8">
              <p className="text-center text-muted-foreground text-base leading-relaxed max-w-2xl mx-auto">
                Colaboramos con tiendas delicatessen, distribuidores y socios
                profesionales que valoran la autenticidad, calidad y
                trazabilidad de nuestro aceite de oliva virgen extra.
              </p>

              <div className="grid md:grid-cols-3 gap-6 py-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <TrendingUp className="size-6 text-primary" />
                  </div>
                  <h3 className="text-foreground text-lg font-serif">
                    Suministro Directo
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Acceso directo al productor con condiciones especiales para
                    profesionales del sector gourmet.
                  </p>
                </div>

                <div className="flex flex-col items-center text-center space-y-3">
                  <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <HeartHandshake className="size-6 text-primary" />
                  </div>
                  <h3 className="text-foreground text-lg font-serif">
                    Soporte Marketing
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Material promocional, historia de marca y apoyo continuo
                    para potenciar tus ventas.
                  </p>
                </div>

                <div className="flex flex-col items-center text-center space-y-3">
                  <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Building2 className="size-6 text-primary" />
                  </div>
                  <h3 className="text-foreground text-lg font-serif">
                    Distribución Exclusiva
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Posibilidad de acuerdos de exclusividad territorial para
                    socios estratégicos.
                  </p>
                </div>
              </div>

              <div className="flex justify-center pt-4">
                <Button asChild className="btn">
                  <Link to="#contacto">Solicitar Dossier Profesional</Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}